import React from "react";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
import "./home-page.css";

export default function PrivacyPolicy() {
  return (
    <div className="home-pro">
      <SEO
        title="Privacy Policy | QrMenu Italia"
        description="Informativa privacy di QrMenu Italia sul trattamento dei dati personali."
        canonical="https://qrmenu-italia.it/privacy-policy"
        image="https://qrmenu-italia.it/logo512.png"
        keywords="privacy policy qrmenu, privacy qrmenu italia"
      />

      <MarketingNavbar />

      <section
        className="hp-final"
        style={{
          minHeight: "100vh",
          paddingTop: "140px",
          paddingBottom: "80px",
        }}
      >
        <div
          className="hp-final-inner"
          style={{
            maxWidth: "900px",
            textAlign: "left",
          }}
        >
          <h1 className="hp-final-h2">Privacy Policy</h1>

          <p className="hp-final-sub">
            Informativa sul trattamento dei dati personali degli utenti di
            QrMenu Italia.
          </p>

          <div
            style={{
              marginTop: "40px",
              lineHeight: "1.8",
            }}
          >
            <h2>1. Titolare del trattamento</h2>

            <p>
              Il titolare del trattamento dei dati personali raccolti tramite
              il sito QrMenu Italia è:
            </p>

            <p>
              <strong>Michelangelo Candiano</strong>
              <br />
              Email:{" "}
              <a href="mailto:info@qrmenu-italia.it">
                info@qrmenu-italia.it
              </a>
            </p>

            <h2>2. Dati raccolti</h2>

            <p>
              Attraverso il sito possono essere raccolti dati personali forniti
              volontariamente dall'utente tramite i moduli di contatto o di
              richiesta di informazioni.
            </p>

            <p>
              Tali dati possono comprendere nome, indirizzo email, numero di
              telefono, provincia, nome del locale e le informazioni inserite
              liberamente nel messaggio.
            </p>

            <p>
              Possono inoltre essere raccolti dati tecnici relativi
              all'utilizzo del sito e del dispositivo utilizzato, nei limiti
              previsti dalle impostazioni e dal consenso espresso dall'utente.
            </p>

            <h2>3. Finalità del trattamento</h2>

            <p>I dati personali possono essere utilizzati per:</p>

            <ul>
              <li>rispondere alle richieste di contatto e informazioni;</li>
              <li>gestire richieste di prova o dimostrazione del servizio;</li>
              <li>
                fornire assistenza e comunicazioni relative ai servizi QrMenu;
              </li>
              <li>garantire il funzionamento e la sicurezza della piattaforma;</li>
              <li>
                analizzare l'utilizzo del sito, esclusivamente quando previsto
                e consentito dalle preferenze espresse dall'utente.
              </li>
            </ul>

            <h2>4. Base giuridica del trattamento</h2>

            <p>
              Il trattamento dei dati forniti tramite i moduli di contatto è
              effettuato per rispondere alle richieste dell'interessato e per
              svolgere attività precontrattuali eventualmente richieste dallo
              stesso.
            </p>

            <p>
              Gli eventuali trattamenti basati sul consenso dell'utente vengono
              effettuati solo dopo che tale consenso è stato espresso.
            </p>

            <h2>5. Modalità del trattamento</h2>

            <p>
              I dati vengono trattati mediante strumenti informatici e
              telematici adottando misure organizzative e tecniche adeguate a
              proteggerli da accessi non autorizzati, perdita, modifica o
              divulgazione indebita.
            </p>

            <h2>6. Servizi e fornitori esterni</h2>

            <p>
              QrMenu Italia utilizza servizi tecnologici necessari al
              funzionamento della piattaforma. Tra questi possono rientrare
              servizi di infrastruttura cloud, database, autenticazione,
              archiviazione, notifiche, analisi statistiche e servizi collegati
              alle funzionalità offerte dalla piattaforma.
            </p>

            <p>
              Il sito utilizza servizi Firebase di Google per alcune funzioni
              tecniche e applicative. Google Analytics può essere utilizzato
              per raccogliere informazioni statistiche sull'utilizzo del sito
              solo secondo le preferenze di consenso impostate dall'utente.
            </p>

            <h2>7. Conservazione dei dati</h2>

            <p>
              I dati personali vengono conservati per il tempo necessario a
              gestire la richiesta dell'utente e per il periodo eventualmente
              necessario all'adempimento di obblighi di legge o alla tutela dei
              diritti del titolare.
            </p>

            <h2>8. Comunicazione dei dati</h2>

            <p>
              I dati non vengono diffusi. Possono essere trattati da fornitori
              tecnologici e soggetti che supportano il funzionamento del
              servizio, esclusivamente per le finalità necessarie
              all'erogazione delle relative attività.
            </p>

            <h2>9. Diritti dell'interessato</h2>

            <p>
              Nei casi previsti dalla normativa applicabile, l'interessato può
              richiedere l'accesso ai propri dati personali, la rettifica,
              l'aggiornamento, la cancellazione, la limitazione del trattamento,
              l'opposizione al trattamento e, quando applicabile, la portabilità
              dei dati.
            </p>

            <p>
              Le richieste possono essere inviate a{" "}
              <a href="mailto:info@qrmenu-italia.it">
                info@qrmenu-italia.it
              </a>
              .
            </p>

            <p>
              L'interessato può inoltre proporre reclamo all'Autorità Garante
              per la protezione dei dati personali nei casi previsti dalla
              normativa.
            </p>

            <h2>10. Modifiche alla presente informativa</h2>

            <p>
              La presente Privacy Policy potrà essere aggiornata in seguito
              all'evoluzione dei servizi QrMenu Italia, all'introduzione di
              nuove funzionalità o a modifiche normative.
            </p>

            <p>
              <strong>Ultimo aggiornamento: luglio 2026.</strong>
            </p>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}